import React from "react";
import "./legal.css";
import Footer from "./Footer";

const DataProcessing = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Data Processing</h1>

        <p>
          KostPadi processes customer and business data solely for the purpose
          of delivering accounting, invoicing, inventory, and reporting
          services.
        </p>

        <h2>Categories of Data</h2>

        <ul>
          <li>Customer information</li>
          <li>Invoice records</li>
          <li>Financial transactions</li>
          <li>Inventory data</li>
          <li>Authentication records</li>
        </ul>

        <h2>Processing Activities</h2>

        <ul>
          <li>Cloud storage</li>
          <li>Authentication</li>
          <li>Payment processing</li>
          <li>Analytics and monitoring</li>
          <li>AI-assisted features</li>
        </ul>

        <h2>Compliance</h2>

        <p>
          KostPadi implements appropriate safeguards in line with the Nigeria
          Data Protection Act (NDPA) 2023.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default DataProcessing;
